import type { ComboboxOption } from '@standardsdigital/ui-components/Combobox';
import RadioGroup from '@standardsdigital/ui-components/RadioGroup';
import RadioGroupItem from '@standardsdigital/ui-components/RadioGroupItem';
import { useTranslation } from 'react-i18next';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';

interface PreviousVersionsRadioProps {
  options: ComboboxOption[];
  value: number;
  onChange: (value: number) => void;
  isDirty: boolean;
  disabled: boolean;
}

function PreviousVersionsRadio({
  options,
  value,
  onChange,
  isDirty,
  disabled,
}: Readonly<PreviousVersionsRadioProps>) {
  const { t } = useTranslation();

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <RadioGroup
        required
        label={t('serviceLevels.form.previousVersions')}
        layout="horizontal"
        value={String(value)}
        onValueChange={(nextValue) => onChange(Number(nextValue))}
        disabled={disabled}
      >
        {options.map((option) => (
          <RadioGroupItem
            key={option.value}
            value={option.value}
            label={option.label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FieldStatusWrapper>
  );
}

export default PreviousVersionsRadio;
